import { useLayoutEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";

export const handleMaxInputLines = (e) => {
  const textarea = e.currentTarget;
  const lines = textarea.value.split("\n");
  if (lines.length > 3) {
    textarea.value = lines.slice(0, 3).join("\n");
  }
};
// const [animationState, setAnimationState] = useState(true);

export const bodyHiddenOverflow = () => {
  document.body.style.overflowY = "hidden";
};

export const getColor = (tagId, op) => {
  const hue = tagId * 2716;
  return `hsla(${hue % 360}, 50%, 50%, ${op})`;
};
